import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { ReferralSummary } from 'frontend/types/referral';

interface ReferralSummaryState {
  referralSummaryData: ReferralSummary | null;
}

const referralSummary: Module<ReferralSummaryState, RootState> = {
  namespaced: true,
  state: {
    referralSummaryData: null,
  },
  mutations: {
    setValue(state: ReferralSummaryState, value: ReferralSummary): void {
      state.referralSummaryData = value;
    },
  },
  actions: {},
};

export default referralSummary;
